module.exports = __webpack_public_path__ + "img/ROUND SHADES RED.179a3ba.svg";